<template>
  <base-page>
    <Filters model="tasks" color="tasks" slot="left-column" />
    <router-view :key="$route.fullPath" />
  </base-page>
</template>

<script>
import { Filters } from '../../components/filters'

export default {
  name: 'TasksPage',
  components: { Filters },

  meta () {
    return {
      titleTemplate: title => `${title} - Tâches | AGORA`
    }
  },

  preFetch ({ store, currentRoute, previousRoute, redirect, ssrContext }) {
    if (!store.getters['tasks/getFilters']) {
      store.dispatch('tasks/fetchFilters')
    }
  },

  mounted () {
    this.$store.commit('pages/setBreadcrumbs', [
      { label: this.$t('global.home'), to: { name: 'home' }, icon: 'home' },
      {}
    ])

    this.$store.commit('pages/setPageTitle', this.$t('tasks.tasks_list'))

    this.$store.commit('pages/setTabs', [
      { name: 'tous', label: 'Tous', to: { name: 'tasks-list-tous' } },
      { name: 'brouillon', label: 'Brouillon', to: { name: 'tasks-list-brouillon' } },
      // { name: 'planifiee', label: 'Planifiée', to: { name: 'tasks-list-planifiee' } },
      { name: 'en-cours', label: 'En cours', to: { name: 'tasks-list-en-cours' } },
      { name: 'a-valider', label: 'À valider', to: { name: 'tasks-list-a-valider' } },
      { name: 'terminee', label: 'Terminée', to: { name: 'tasks-list-terminee' } },
      { name: 'abandonnee', label: 'Abandonnée', to: { name: 'tasks-list-abandonnee' } }
    ])
  }
}
</script>
